export default {
  id: '0cbd541296',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n  <div class="page pin" data-name="pin">\n\n    <!-- Navbar -->\n    <div class="navbar pin__navbar no-shadow">\n      <div class="navbar-bg"></div>\n      <div class="navbar-inner">\n        <div class="left">\n          <a href="#" class="link back pin__back" aria-label="Back">\n            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="15 18 9 12 15 6"/></svg>\n          </a>\n        </div>\n        <div class="title pin__navbar-title">My PINs</div>\n        <div class="right"></div>\n      </div>\n    </div>\n\n    <div class="page-content pin__content">\n\n      <!-- Hero -->\n      <div class="pin__hero">\n        <div class="pin__hero-glow"></div>\n        <div class="pin__hero-top">\n          <div class="pin__hero-emblem">\n            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#C9A969" stroke-width="1.7"><circle cx="7.5" cy="15.5" r="4.5"/><path d="M10.7 12.3 19 4m-3 0h3v3"/><path d="m15 8 2 2"/></svg>\n          </div>\n          <div class="pin__hero-id">\n            <div class="pin__hero-label">Total PINs Assigned</div>\n            <div class="pin__hero-total pin__total">0</div>\n          </div>\n        </div>\n        <div class="pin__hero-stats">\n          <div class="pin__hstat">\n            <span class="pin__hstat-dot pin__hstat-dot--green"></span>\n            <b class="pin__active">0</b> Active\n          </div>\n          <div class="pin__hstat-sep"></div>\n          <div class="pin__hstat">\n            <span class="pin__hstat-dot pin__hstat-dot--gold"></span>\n            <b class="pin__redeemed">0</b> Redeemed\n          </div>\n        </div>\n      </div>\n\n      <!-- Filter -->\n      <div class="pin__filter">\n        <button type="button" class="pin__filter-tab pin__filter-tab--on" data-filter="all">All <span class="pin__filter-count" data-count="all">0</span></button>\n        <button type="button" class="pin__filter-tab" data-filter="active">Active <span class="pin__filter-count" data-count="active">0</span></button>\n        <button type="button" class="pin__filter-tab" data-filter="redeemed">Redeemed <span class="pin__filter-count" data-count="redeemed">0</span></button>\n      </div>\n\n      <!-- PIN cards injected here -->\n      <div class="pin__list">\n        <div class="pin__loading">Loading your PINs\u2026</div>\n      </div>\n\n      <!-- No results for current filter -->\n      <div class="pin__none" style="display:none;">No PINs in this category.</div>\n\n      <!-- Empty state -->\n      <div class="pin__empty" style="display:none;">\n        <div class="pin__empty-icon">\n          <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="#C9A969" stroke-width="1.6"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/><circle cx="12" cy="16" r="1.4" fill="#C9A969" stroke="none"/></svg>\n        </div>\n        <div class="pin__empty-title">No PINs assigned</div>\n        <div class="pin__empty-sub">You don\'t have any PINs yet. They\'ll appear here once assigned to your account.</div>\n      </div>\n\n      <div class="pin__end-gap"></div>\n    </div>\n  </div>\n';
      return r;
    }(this);
  },
  style: `
/* ════════ MY PINS PAGE (pin__*) ════════ */
.pin { background: #0A0A0B !important; }
.pin__content {
  background:
    radial-gradient(130% 45% at 50% 0%, rgba(201,169,105,0.10) 0%, transparent 56%),
    #0A0A0B !important;
  padding: 14px 14px 0 !important;
  margin-top: 60px !important;
}
.pin__navbar { background: linear-gradient(180deg, #100E09 0%, #0B0A07 100%) !important; }
.pin__navbar .navbar-bg { background: transparent !important; }
.pin__navbar-title { color: var(--gold) !important; font-weight: 700; }
.pin__back { color: rgba(201,169,105,0.85) !important; }

/* Hero */
.pin__hero {
  position: relative; overflow: hidden;
  background:
    radial-gradient(100% 100% at 100% 0%, rgba(201,169,105,0.16) 0%, transparent 55%),
    linear-gradient(150deg, #221b0d 0%, #161109 55%, #1a150c 100%);
  border: 1px solid rgba(201,169,105,0.24);
  border-radius: 22px; padding: 18px;
  box-shadow: inset 0 1px 0 rgba(223,194,136,0.20), 0 16px 36px -18px rgba(0,0,0,0.8);
}
.pin__hero::before {
  content: ''; position: absolute; top: 0; left: 10%; right: 10%; height: 1px;
  background: linear-gradient(90deg, transparent, rgba(223,194,136,0.75), transparent);
}
.pin__hero-glow {
  position: absolute; top: -50px; right: -40px; width: 170px; height: 170px;
  border-radius: 50%; pointer-events: none;
  background: radial-gradient(circle, rgba(201,169,105,0.16), transparent 65%);
}
.pin__hero-top { position: relative; z-index: 1; display: flex; align-items: center; gap: 13px; }
.pin__hero-emblem {
  width: 50px; height: 50px; border-radius: 14px; flex-shrink: 0;
  background: linear-gradient(145deg, rgba(201,169,105,0.24), rgba(201,169,105,0.08));
  border: 1px solid rgba(201,169,105,0.32);
  display: flex; align-items: center; justify-content: center;
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.20);
}
.pin__hero-label { font-size: 11.5px; color: rgba(255,255,255,0.45); font-weight: 500; }
.pin__hero-total {
  font-size: 32px; font-weight: 800; line-height: 1; margin-top: 4px; letter-spacing: -0.02em;
  background: linear-gradient(92deg, #ffffff, #f3e9d2 55%, #C9A969);
  -webkit-background-clip: text; background-clip: text; -webkit-text-fill-color: transparent;
}
.pin__hero-stats {
  position: relative; z-index: 1;
  display: flex; align-items: center; gap: 14px;
  margin-top: 16px; padding-top: 14px;
  border-top: 1px solid rgba(201,169,105,0.14);
  font-size: 12.5px; color: rgba(255,255,255,0.55);
}
.pin__hstat { display: flex; align-items: center; gap: 6px; }
.pin__hstat b { color: #fff; font-weight: 800; }
.pin__hstat-dot { width: 7px; height: 7px; border-radius: 50%; }
.pin__hstat-dot--green { background: #4ADE80; box-shadow: 0 0 6px rgba(74,222,128,0.55); }
.pin__hstat-dot--gold { background: #C9A969; box-shadow: 0 0 6px rgba(201,169,105,0.5); }
.pin__hstat-sep { width: 1px; height: 16px; background: rgba(201,169,105,0.18); }

/* Filter segmented control */
.pin__filter {
  display: flex; gap: 4px; margin-top: 16px;
  background: rgba(0,0,0,0.28);
  border: 1px solid rgba(201,169,105,0.10);
  border-radius: 13px; padding: 4px;
}
.pin__filter-tab {
  flex: 1; padding: 9px 0; border: none; background: transparent;
  color: rgba(255,255,255,0.45); font-size: 12.5px; font-weight: 700;
  border-radius: 9px; cursor: pointer; letter-spacing: 0.01em;
  transition: color 0.2s, background 0.2s, box-shadow 0.2s;
}
.pin__filter-tab--on {
  background: linear-gradient(135deg, rgba(201,169,105,0.24), rgba(201,169,105,0.12));
  color: #dfc288;
  box-shadow: inset 0 1px 0 rgba(223,194,136,0.25), 0 2px 8px rgba(0,0,0,0.30);
}
.pin__filter-count {
  display: inline-block; min-width: 18px; padding: 0 5px; margin-left: 3px;
  font-size: 10px; font-weight: 800; line-height: 17px; text-align: center;
  border-radius: 9px;
  background: rgba(201,169,105,0.14); color: rgba(201,169,105,0.80);
}
.pin__filter-tab--on .pin__filter-count { background: rgba(223,194,136,0.28); color: #f3e0a8; }

/* Messages */
.pin__loading, .pin__none {
  text-align: center; color: rgba(255,255,255,0.42);
  font-size: 13px; padding: 26px 0;
}

/* PIN cards (premium voucher) */
.pin__list { display: flex; flex-direction: column; gap: 12px; margin-top: 16px; margin-bottom: 40px; }
.pin__card {
  position: relative; overflow: hidden;
  background:
    radial-gradient(95% 70% at 100% 0%, rgba(201,169,105,0.10) 0%, transparent 55%),
    linear-gradient(155deg, #1a160e 0%, #121110 100%);
  border: 1px solid rgba(201,169,105,0.18);
  border-radius: 18px; padding: 16px;
  box-shadow: inset 0 1px 0 rgba(201,169,105,0.12), 0 14px 30px -18px rgba(0,0,0,0.8);
}
.pin__card::before {
  content: ''; position: absolute; top: 0; left: 12%; right: 12%; height: 1px;
  background: linear-gradient(90deg, transparent, rgba(223,194,136,0.5), transparent);
}
/* notch cut-outs for the voucher look */
.pin__card::after {
  content: ''; position: absolute; left: -7px; top: 50%; transform: translateY(-50%);
  width: 14px; height: 14px; border-radius: 50%;
  background: #0A0A0B; border: 1px solid rgba(201,169,105,0.18);
}
.pin__card--redeemed { opacity: 0.9; }
.pin__card--redeemed::before { background: linear-gradient(90deg, transparent, rgba(201,169,105,0.3), transparent); }

.pin__card-head {
  display: flex; align-items: center; justify-content: space-between;
  margin-bottom: 13px;
}
.pin__status {
  display: inline-flex; align-items: center; gap: 5px;
  font-size: 10px; font-weight: 700; border-radius: 20px; padding: 3px 9px;
  text-transform: uppercase; letter-spacing: 0.05em;
}
.pin__status-dot { width: 5px; height: 5px; border-radius: 50%; }
.pin__status--active { color: #4ADE80; background: rgba(74,222,128,0.10); border: 1px solid rgba(74,222,128,0.22); }
.pin__status--active .pin__status-dot { background: #4ADE80; box-shadow: 0 0 5px rgba(74,222,128,0.6); }
.pin__status--redeemed { color: rgba(201,169,105,0.85); background: rgba(201,169,105,0.10); border: 1px solid rgba(201,169,105,0.22); }
.pin__status--redeemed .pin__status-dot { background: #C9A969; }
.pin__amount { font-size: 14px; font-weight: 800; color: #dfc288; }

/* Coupon-code box */
.pin__code-box {
  display: flex; align-items: center; gap: 10px;
  background: rgba(0,0,0,0.30);
  border: 1.5px dashed rgba(201,169,105,0.35);
  border-radius: 12px; padding: 0 8px 0 13px; height: 50px;
}
.pin__code-label {
  font-size: 8.5px; font-weight: 700; letter-spacing: 0.14em;
  color: rgba(201,169,105,0.55);
  border-right: 1px solid rgba(201,169,105,0.20); padding-right: 10px;
}
.pin__code {
  flex: 1; min-width: 0;
  font-size: 19px; font-weight: 800; color: #fff;
  letter-spacing: 0.14em; font-family: 'Courier New', monospace;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.pin__card--redeemed .pin__code { color: rgba(255,255,255,0.5); text-decoration: line-through; text-decoration-color: rgba(201,169,105,0.4); }
.pin__copy {
  width: 38px; height: 38px; border-radius: 10px; flex-shrink: 0;
  background: linear-gradient(135deg, rgba(201,169,105,0.22), rgba(201,169,105,0.10));
  border: 1px solid rgba(201,169,105,0.30);
  color: #dfc288; display: flex; align-items: center; justify-content: center; cursor: pointer;
  transition: background 0.15s, transform 0.1s;
}
.pin__copy:active { background: rgba(201,169,105,0.30); transform: scale(0.92); }

.pin__redeemed-by {
  display: flex; align-items: center; gap: 6px;
  margin-top: 13px; padding-top: 12px;
  border-top: 1px solid rgba(201,169,105,0.10);
  font-size: 12px; color: rgba(255,255,255,0.45);
}
.pin__redeemed-by svg { color: rgba(201,169,105,0.6); flex-shrink: 0; }
.pin__redeemed-by b { color: rgba(255,255,255,0.82); font-weight: 700; }

/* Empty state */
.pin__empty { text-align: center; padding: 40px 24px; }
.pin__empty-icon {
  width: 72px; height: 72px; border-radius: 50%; margin: 0 auto 16px;
  background: radial-gradient(circle, rgba(201,169,105,0.14), rgba(201,169,105,0.04));
  border: 1.5px solid rgba(201,169,105,0.26);
  display: flex; align-items: center; justify-content: center;
}
.pin__empty-title { font-size: 16px; font-weight: 700; color: #fff; }
.pin__empty-sub { font-size: 12.5px; color: rgba(255,255,255,0.42); margin-top: 7px; line-height: 1.5; max-width: 280px; margin-left: auto; margin-right: auto; }

.pin__end-gap { height: 30px; }
`,
  styleScoped: false
};